<template>
  <button type="button" class="btn btn-link no_border padding" @click="clicked(element, index)">
    <i class="pulsante_comando" v-bind:class="[classImage]"></i>
  </button>
</template>
<script>
export default {
  name: 'actionButton',
  props: ['element', 'classImage', 'type', 'index'],
  components: {},
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {},
  methods: {
    clicked() {
      this.$emit('clicked', { element: this.element, index: this.index, type: this.type });
    },
  },
};
</script>

<style lang="scss" scoped>
.padding {
  padding: 0px 10px;
}
</style>
